module.exports = __webpack_public_path__ + "static/media/sawmill.a12c1bb3.png";